






























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import ChangeClicker from '@/components/lfs/NewStatistics/Elements/ChangeClicker.vue';
import IQuestion from "@/components/icons/IQuestion.vue";
import TooltipSimple from "@/components/UI/TooltipSimple.vue";


@Component({
  name: 'DataScanFromCategory',
  components: {TooltipSimple, IQuestion, ChangeClicker}
})
export default class DataScanFromCategory extends Vue {
  typeDiagram = 'bar'

  changeTypeDiagramm(type:string) {
    this.chartOptions.chart.type = type
  }

  @Prop({type: Array, default: []}) items!: string[]
  @Prop({type: String, default: ''}) title!: string[]
  @Prop({ type: Boolean, default: false}) protected loading!: boolean
  product:any[] = []

  @Watch('items', { immediate: true, deep: true })
  getItems(NewVal: any) {
    this.chartOptions.chart.height = this.items.length * 80 > 400 ? String(this.items.length * 80) : '400'
    this.chartOptions.series = NewVal
  }

  chartOptions = {
    chart: {
      style: {"fontSize": "12px"},
      height: this.items.length * 80 > 400 ? String(this.items.length * 80) : '400',
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginRight: '30',
      marginLeft: '100',
      marginTop: '30',
      marginBottom: '90',
      type: this.typeDiagram,
    },
    title: {
      text: ''
    },
    subtitle: {},
    credits: {
      enabled: false
    },
    tooltip: {
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0
      },
      formatter: function (): any {
        const context: any = this
        return '<div class="statistics-v4-tooltip"><span class="statistics-v4-tooltip-subtitle">'
          + context.point.series.name + ': ' + context.y + '</span></div>'
      },
    },
    xAxis: {
      type: 'category',
      labels: {
        enabled: false,
        rotation: 0,
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif'
        }
      },
      gridLineDashStyle: 'dot',
      gridLineWidth: 2,
      tickPixelInterval: 200,
    },
    yAxis: {
      min: 0,
      allowDecimals: false,
      title: null,
      gridLineDashStyle: 'dot',
      gridLineWidth: 2,
      tickPixelInterval: 200,
    },
    legend: {
      enabled: true,
      layout: 'horizontal',
      verticalAlign: 'bottom',
      floating: false,
      itemStyle: {
        fontSize: '15',
        fontWeight: '700',
        color: ' #0A0A0A',
        textOverflow: 'ellipsis'
      }
    },
    plotOptions: {
      column: {
        colorByPoint: true
      },
      bar: {
        //colorByPoint: true,
        dataLabels: {
          enabled: true,
          inside: false,
          color: '#000'
        }
      },
      pie: {
        chart: {
          marginLeft: 0,
          marginBottom: '10',
          height: '505'
        },
        legend: {
          enabled: false,
          align: 'left',
          verticalAlign: 'top',
          layout: 'vertical',
          x: 0,
          y: 100,
        },
        cursor: 'pointer',
        dataLabels: {
          alignTo: 'plotEdges',
          style: {
            color:'black',
            shadow:false,
            textOverflow: 'clip'
          }
        },
        showInLegend: false,
        startAngle: -180,
        endAngle: 180,
        center: ['50%', '50%'],
        size: '90%'
      },
      series: {
        stacking: 'normal'
      },
    },
    series: this.items
  }

}
